
import {computed, ref} from 'vue'
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast";
import router from "@/router";

export default {
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const toast = useToast();
    const defaultMenu = [
    ];

    const appMenus = computed(() => {
      var listReport = [];
      if(store.state.permission == "user") {
        listReport = store.state.report.split(",");
      }
      const list = ref([
        {label: "BC Cơ sở lao động", key: "bc1", value: {
            label:'BC Cơ sở lao động',
            icon:'pi pi-fw pi-file',
            url: '/baoCaoCoSoLaoDong'
          }
        },
        {label: "BC Cơ sở lao động đã gởi", key: "bc1", value: {
            label:'BC Cơ sở lao động đã gới',
            icon:'pi pi-fw pi-replay',
            url: '/baoCaoCoSoLaoDongDaGoi'
          }
        },
        {label: "BC YTLĐ tuyến huyện", key: "bc2", value: {
            label:'BC YTLĐ tuyến huyện',
            icon:'pi pi-fw pi-file',
            url: '/baoCaoTuyenHuyen'
          }},
        {label: "BC YTLĐ tuyến huyện đã gởi", key: "bc2", value: {
            label:'BC YTLĐ tuyến huyện đã gởi',
            icon:'pi pi-fw pi-replay',
            url: '/baoCaoTuyenHuyenDaGoi'
          }},
        {label: "BC Kiểm dịch y tế", key: "bc3", value: {
            label:'BC Kiểm dịch y tế',
            icon:'pi pi-fw pi-file',
            url: '/baoCaoKiemDichYTe'
          }},
        {label: "BC Kiểm dịch y tế đã gởi", key: "bc3", value: {
            label:'BC Kiểm dịch y tế đã gởi',
            icon:'pi pi-fw pi-replay',
            url: '/baoCaoHDYTKDDaGoi'
          }},
        {label: "BC công tác y tế trường học", key: "bc4", value: {
            label:'BC công tác y tế trường học',
            icon:'pi pi-fw pi-file',
            url: '/baoCaoCongTacYTeTruongHoc'
          }},
        {label: "BC công tác y tế trường học đã gởi", key: "bc4", value: {
            label:'BC công tác y tế trường học đã gởi',
            icon:'pi pi-fw pi-replay',
            url: '/baoCaoCongTacYTeTruongHocDaGoi'
          }},
        {label: "BC vệ sinh nước sạch", key: "bc5", value: {
            label:'BC vệ sinh nước sạch',
            icon:'pi pi-fw pi-file',
            url: '/baoCaoKQVSNuocSach'
          }
        },
        {label: "BC vệ sinh nước sạch đã gởi", key: "bc5", value: {
            label:'BC vệ sinh nước sạch đã gởi',
            icon:'pi pi-fw pi-replay',
            url: '/baoCaoKQVSNuocSachDaGoi'
          }
        },
        {label: "BC tiêm vắc xin", key: "bc6", value: {
            label:'BC tiêm vắc xin',
            icon:'pi pi-fw pi-file',
            url: '/baoCaoVacxin'
          }
        },
        {label: "BC tiêm vắc xin đã gởi", key: "bc6", value: {
            label:'BC tiêm vắc xin đã gởi',
            icon:'pi pi-fw pi-replay',
            url: '/baoCaoVacxinDaGoi'
          }
        },
        {label: "BC tình hình sd vắc xin và tiêm chủng", key: "bc7", value: {
            label:'BC tình hình sử dụng vắcxin',
            icon:'pi pi-fw pi-file',
            url: '/baoCaoTinhHinhSDVacXin'
          }
        },
        {label: "BC tình hình sd vắc xin TC đã gởi", key: "bc7", value: {
            label:'BC tình hình sử dụng vắcxin',
            icon:'pi pi-fw pi-replay',
            url: '/baoCaoTinhHinhDaGoi'
          }
        },
        {label: "BC sàng lọc bệnh KLN và KSKDK", key: "bc8", value: {
            label:'BC sàng lọc bệnh và KSKDK',
            icon:'pi pi-fw pi-file',
            url: '/baoCaoSanLocBenhKLNVaKSK'
          }
        },
        {label: "BC sàng lọc bệnh KLN và KSKDK đã gởi", key: "bc8", value: {
            label:'BC sàng lọc bệnh và KSKDK đã gởi',
            icon:'pi pi-fw pi-file',
            url: '/baoCaoSanLocDaGoi'
          }
        },
      ]);

      const userMenu = ref([] as object[]);
      listReport.forEach(x => {
        list.value.forEach(y =>{
          if(x == y.key){
            userMenu.value.push(
                y.value
            );
          }
        })
      })
      userMenu.value.push(
          {
            label:'Đổi mật khẩu',
            icon:'pi pi-fw pi-cog',
            url: '/updatePasswordPage'
          },
      )
      const adminMenu = [
        {
          label:'BC Cơ sở lao động',
          icon:'pi pi-fw pi-file',
          url: '/baoCaoCoSoLaoDong'
        },
        {
          label:'BC Cơ sở lao động đã gởi',
          icon:'pi pi-fw pi-replay',
          url: '/baoCaoCoSoLaoDongDaGoi'
        },
        {
          label:'BC YTLĐ tuyến huyện',
          icon:'pi pi-fw pi-file',
          url: '/baoCaoTuyenHuyen'
        },
        {
          label:'BC YTLĐ tuyến huyện đã gởi',
          icon:'pi pi-fw pi-replay',
          url: '/baoCaoTuyenHuyenDaGoi'
        },
        {
          label:'BC Kiểm dịch y tế',
          icon:'pi pi-fw pi-file',
          url: '/baoCaoKiemDichYTe'
        },
        {
          label:'BC Kiểm dịch y tế đã gởi',
          icon:'pi pi-fw pi-replay',
          url: '/baoCaoHDYTKDDaGoi'
        },
        {
          label:'BC công tác y tế trường học',
          icon:'pi pi-fw pi-file',
          url: '/baoCaoCongTacYTeTruongHoc'
        },
        {
          label:'BC công tác y tế trường học đã gởi',
          icon:'pi pi-fw pi-replay',
          url: '/baoCaoCongTacYTeTruongHocDaGoi'
        },
        {
          label:'BC vệ sinh nước sạch',
          icon:'pi pi-fw pi-file',
          url: '/baoCaoKQVSNuocSach'
        },
        {
          label:'BC vệ sinh nước sạch đã gởi',
          icon:'pi pi-fw pi-replay',
          url: '/baoCaoKQVSNuocSachDaGoi'
        },
        {
          label:'BC tiêm vắc xin',
          icon:'pi pi-fw pi-file',
          url: '/baoCaoVacxin'
        },
        {
          label:'BC tiêm vắc xin đã gởi',
          icon:'pi pi-fw pi-replay',
          url: '/baoCaoVacxinDaGoi'
        },
        {
          label:'BC tình hình sd vắc xin',
          icon:'pi pi-fw pi-file',
          url: '/baoCaoTinhHinhSDVacXin'
        },
        {
          label:'BC tình hình sd vắc xin đã gởi',
          icon:'pi pi-fw pi-replay',
          url: '/baoCaoTinhHinhDaGoi'
        },
        {
          label:'BC sàng lọc bệnh và KSK',
          icon:'pi pi-fw pi-file',
          url: '/baoCaoSanLocBenhKLNVaKSK'
        },
        {
          label:'BC sàng lọc bệnh và KSK đã gởi',
          icon:'pi pi-fw pi-replay',
          url: '/baoCaoSanLocDaGoi'
        },
        {
          label:'Quản lý đơn vị',
          icon:'pi pi-fw pi-sitemap',
          url: '/donVi'
        },
        {
          label:'Đổi mật khẩu',
          icon:'pi pi-fw pi-cog',
          url: '/updatePasswordPage'
        },
        {
          label:'Tạo tài khoản',
          icon:'pi pi-fw pi-user-plus',
          url: '/taoTaiKhoan'
        },
        {
          label:'Danh sách tài khoản',
          icon:'pi pi-fw pi-users',
          url: '/dsTaiKhoan'
        },
      ];
      if(store.state.permission == "admin") return adminMenu;
      else if(store.state.permission == "user") return userMenu.value;
      else return defaultMenu;
    });


    const logout = () => {
      store.dispatch('clearToken');
      store.dispatch('clearPermission');
      store.dispatch('clearFullName');
      store.dispatch('clearTeam');
      router.push({
        name: 'login',
      });
      toast.add({
        severity:'success',
        summary: 'Đăng xuất',
        detail:'Đã xóa thông tin đăng nhập thành công',
        life: 1000
      });
    }

    return {
      appMenus,
      logout,
    }
  }
}
